import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { JobStatus } from 'components/bulkExports/types';

interface ExportStatusProps {
  status: string;
  completionPercent?: number;
}

const getStatusIcon = (status: string): JSX.Element | null => {
  switch (status) {
    case JobStatus.PENDING:
    case JobStatus.WORKING:
      return <AccessTimeIcon className="BulkExports__TableRow__Icon" />;
    case JobStatus.FAILED:
      return <ErrorOutlineIcon className="BulkExports__TableRow__Icon--Error" />;
    case JobStatus.CANCELED:
    case JobStatus.CANCEL_REQ:
      return <CancelOutlinedIcon className="BulkExports__TableRow__Icon--Error" />;
    case JobStatus.COMPLETE:
    case JobStatus.NO_DATA:
      return <CheckCircleOutlineIcon className="BulkExports__TableRow__Icon--Success" />;
    default:
      return null;
  }
};

function ExportStatus({ status, completionPercent }: ExportStatusProps): JSX.Element {
  return (
    <>
      {getStatusIcon(status)}{' '}
      {status === JobStatus.WORKING ? `${(completionPercent && Math.round(completionPercent)) || 0}% complete` : status}
    </>
  );
}

export default ExportStatus;
